/**
 * Copyright (C) Siemens AG 1996-2026 ALL RIGHTS RESERVED.
 */

import {Component, Input} from '@angular/core';
import {IxModule} from '@siemens/ix-angular';

@Component({
  selector: 'app-dpp-field-label',
  templateUrl: './field-label.component.html',
  imports: [IxModule],
})
export class DppFieldLabelComponent {
  @Input({required: true}) label!: string;
}
